<template >
  <v-col class="py-0">
    <v-row v-if="label">
      <b>{{ this.label }}</b>
    </v-row>
    <v-row v-if="text">
      <p :class="['mb-0 v-input--description', {
        'v-input--description--next': isDescriptionLabel()
      }]" full-width v-html="text"></p>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    label: String,
    params: {
      type: Object,
      default: () => ({}),
    },
    config: Object,
  },
  computed: {
    text() {
      const { text } = this.params;
      if (typeof text === 'function') {
        return text();
      }
      return text;
    },
  },
  methods: {
    isDescriptionLabel() {
      const { aslabel } = this.params;
      return aslabel === 'true';
    },
  },
};
</script>

<style lang="scss">
  .v-application .v-input--description {
    > p {
      margin-bottom: 0;
    }

    &.v-input--description--next > p {
      margin: 20px 0 -10px 0;
    }
  }
</style>
